import React from 'react'
import axios from 'axios'
import { useState } from 'react'    
function CreateAttributeTab() {
   const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    
    const sendData = async (e) => {
        try {
            e.preventDefault();
            const formdata=new FormData();
            formdata.append('name',name);
            formdata.append('description',description);
            const response = await axios.post(process.env.REACT_APP_API_URL+'/api/AttributeTabs', formdata)
            console.log(response);
        }
        catch (error) {
            console.error(error);
        }
    }


  return (
    <>
    <div className=' ml-7 mt-4 text-lg '>
        <h2>
            Create Attribute Tab
        </h2>
    </div>
    <div className="w-full mt-10 ">
      <form className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" onSubmit={sendData} >
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
            Name
          </label>
          <input className="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
          id="name" 
          type="text"
           placeholder="Name"
           onChange={(e)=>setName(e.target.value)}
           />
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="description">
            Description
          </label>
          <textarea className="shadow appearance-none border rounded w-96 h-24 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
           id="description" 
           type="text" 
           placeholder="Description"
            onChange={(e)=>setDescription(e.target.value)}    
           />
        </div>
        <div className="flex items-center justify-between">
          <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button">
            Create Attribute
          </button>
        </div>
      </form>
    </div>
    </>
  )
}

export default CreateAttributeTab